// آدرسِ خلاصه‌شده برای کارت - نه آدرسِ کامل.
//
// روی کارت فقط خیابون به‌دردِ کاربر می‌خوره؛ کدپستی، استان، شهر (که خودِ
// سربرگ/فیلترِ اپ همینو نشون می‌ده) و شماره‌ی پلاک فقط جا می‌گیرن. آدرسِ
// کامل جاش صفحه‌ی جزئیاته (place/[id].tsx که مستقیم b.address رو نشون می‌ده).

/**
 * کدهای استانِ کانادا - محدود و ثابته.
 *
 * صادر می‌شه چون `addressReport.ts` (تحلیلِ آدرس‌ها در ادمین) همینو لازم
 * داره و دو نسخه‌ی این فهرست یعنی روزی که یکی‌شون به‌روز بشه و اون یکی نه.
 */
export const CA_PROVINCES = ['ON', 'QC', 'BC', 'AB', 'MB', 'SK', 'NS', 'NB', 'NL', 'PE', 'NT', 'NU', 'YT'];

/**
 * کدپستیِ کانادا: حرف-عدد-حرف [فاصله؟] عدد-حرف-عدد، مثلِ «K1S 3T5».
 *
 * ⚠ بی‌پرچمِ `g` بمونه: دو فایل همین شیء رو به اشتراک می‌ذارن و رجکسِ
 * سراسری بینشون `lastIndex` رو جابه‌جا می‌کنه.
 */
export const CA_POSTAL_RE = /\b[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d\b/;

const stripPostal = (s: string) => s.replace(CA_POSTAL_RE, '').trim();
const stripTrailingProvince = (s: string) => s.replace(
  /\s+(ON|QC|BC|AB|MB|SK|NS|NB|NL|PE|NT|NU|YT)$/i, '',
).trim();

/**
 * فقط خیابون (بدون شماره) - «366 Bank St, Ottawa, ON K1S 3T5» → «Bank St».
 * شهر رو کرالر/فرم می‌دونه (پارامترِ city)، نه اینکه اسمِ اتاوا این‌جا
 * سخت‌کد شده باشه - وقتی شهرِ دیگه‌ای اضافه شد بازم درست کار می‌کنه.
 */
export function cardAddress(address?: string | null, city?: string | null): string | undefined {
  if (!address) return undefined;

  let parts = address.split(',').map((s) => s.trim()).filter(Boolean);
  parts = parts
    .map((p) => stripTrailingProvince(stripPostal(p)))
    .filter(Boolean)
    .filter((p) => !CA_PROVINCES.includes(p.toUpperCase()))
    .filter((p) => !city || p.toLowerCase() !== city.trim().toLowerCase());

  const street = parts[0];
  if (!street) return undefined;

  // شماره‌ی جلوی خیابون: «366 Bank St» → «Bank St»، «134 Rideau St» → «Rideau St».
  return street.replace(/^\d+[A-Za-z]?[\s-]+/, '').trim() || undefined;
}
